import script from "./CoursesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursesPage.vue?vue&type=script&setup=true&lang=js"

import "./CoursesPage.vue?vue&type=style&index=0&id=bb77ce86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb77ce86"]])

export default __exports__